﻿import {createAsyncStore} from "./async.store";
import {fetchSectionMeasurementMoments} from "../api/measurements.api";

export const sectionMeasurementMomentsStore = createAsyncStore(
    fetchSectionMeasurementMoments
);